export enum TokenStatuses {
  EXPIRED,
  NO_RESTRICTIONS,
  VALID_UNTIL,
}
